import { getFormattedDate, sanitizeValue } from '@helpers/utils';
import css from './index.module.scss';
import { ENQUIRY_TYPE } from '@helpers/constants';

interface QuoteBasicDetailProps {
  data: any;
  quoteDetail: {
    currency1: any;
    currency2: any;
    readableEnquiryNumber: string;
    enquiryType: string;
  };
}

const QuoteBasicDetail = (props: QuoteBasicDetailProps) => {
  const { data, quoteDetail } = props;
  const { currency1, currency2, readableEnquiryNumber, enquiryType } = quoteDetail;

  return (
    <div className={css.basicDetailsContent}>
      <div className={css.basicDetailsContentItem}>
        <div className={css.keyValue}>
          <div className={css.key}>Customer Name</div>
          <div className={css.value}>{sanitizeValue(data?.customer_name)}</div>
        </div>
        <div className={css.keyValue}>
          <div className={css.key}>Enquiry/Deal Name</div>
          <div className={css.value}>{sanitizeValue(data?.deal_name)}</div>
        </div>
        <div className={css.keyValue}>
          <div className={css.key}>Price Validity Until</div>
          <div className={css.value}>{sanitizeValue(getFormattedDate(data?.last_valid_date))}</div>
        </div>
        <div className={css.keyValue}>
          <div className={css.key}>Date </div>
          <div className={css.value}>{sanitizeValue(getFormattedDate(data?.created_at))}</div>
        </div>
      </div>
      <div className={css.basicDetailsContentItem}>
        <div className={css.keyValue}>
          <div className={css.key}>Entity</div>
          <div className={css.value}>{sanitizeValue(data?.entity?.name)}</div>
        </div>

        <div className={css.keyValue}>
          <div className={css.key}>Payment Terms</div>
          <div className={css.value}>{sanitizeValue(data?.readable_payment_terms)}</div>
        </div>

        <div className={css.keyValue}>
          <div className={css.key}>Expected Delivery Schedule</div>
          <div className={css.value}>{sanitizeValue(data?.expected_delivery_schedule)}</div>
        </div>
        <div className={css.keyValue}>
          <div className={css.key}>Created By</div>
          <div className={css.value}>
            {sanitizeValue(data?.created_by?.given_name)}{' '}
            {sanitizeValue(data?.created_by?.family_name, '')}
          </div>
        </div>
      </div>
      <div className={css.basicDetailsContentItem}>
        <div className={css.keyValue}>
          <div className={css.key}>Enquiry Number </div>
          <div className={css.value}>{sanitizeValue(readableEnquiryNumber)} </div>
        </div>
        {enquiryType === ENQUIRY_TYPE.INTERNATIONAL && (
          <div className={css.keyValue}>
            <div className={css.key}>FxRate</div>
            <div className={css.value}>
              {data?.fx_rate && currency1?.value && currency2?.value
                ? `1 ${currency1.value} = ${data.fx_rate} ${currency2.value}`
                : '-'}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuoteBasicDetail;
